import { render, staticRenderFns } from "./Graphs.vue?vue&type=template&id=632784a6&"
import script from "./Graphs.vue?vue&type=script&lang=js&"
export * from "./Graphs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports